export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5139.645f337a.jpg";